// eslint-disable-next-line max-classes-per-file
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { RefreshSqlEndpointActivity } from 'app/model/pipeline/refreshsqlendpoint.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { IRefreshSqlEndpointActivity, ReferenceAdapter, FabricSqlEndpointMetadataLinkedService, ModelConstants } from 'shell-models-lib';
import { ActivityAsyncAdapter } from '../activity.adapter';
import { getFabricLsForParameterizedConnections } from '../../utils';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(RefreshSqlEndpointActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        linkedServiceName: '*',
        policy: '*',
        dependsOn: '*',
        userProperties: '*',
        connectionSettings: '*',
        typeProperties: {
            sqlEndpointId: '*',
            workspaceId: '*',
            timeout: '*',
            recreateTables: '*'
        }
    }
})
export class RefreshSqlEndpointActivityAdapter extends ActivityAsyncAdapter<RefreshSqlEndpointActivity, IRefreshSqlEndpointActivity> {

    protected async _toResource(activity: RefreshSqlEndpointActivity): Promise<IRefreshSqlEndpointActivity> {
        const modelRefreshSqlEndpointActivity = super._getCommonActivityProperties(
            activity, Metamodel.modelFor(RefreshSqlEndpointActivity).name) as IRefreshSqlEndpointActivity;

        modelRefreshSqlEndpointActivity.typeProperties = {
            sqlEndpointId: ValueAdapter.toResource(activity, RefreshSqlEndpointActivity.SQLENDPOINTID),
            workspaceId: ValueAdapter.toResource(activity, RefreshSqlEndpointActivity.WORKSPACEID),
            timeout: ValueAdapter.toResource(activity, RefreshSqlEndpointActivity.TIMEOUT),
            recreateTables: ValueAdapter.toResource(activity, RefreshSqlEndpointActivity.RECREATE_TABLES)
        };

        modelRefreshSqlEndpointActivity.linkedServiceName = this._toLinkedServiceReferenceModel(activity.fabricSqlEndpointMetadataLinkedService,
            activity.linkedServiceParameters);

        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            _.merge(modelRefreshSqlEndpointActivity, parsed);
        }

        return modelRefreshSqlEndpointActivity;
    }

    protected async _toModel(modelActivity: IRefreshSqlEndpointActivity): Promise<RefreshSqlEndpointActivity> {
        const activity: RefreshSqlEndpointActivity = RefreshSqlEndpointActivity.MODEL.create<RefreshSqlEndpointActivity>(modelActivity.name, modelActivity.description);
        this._updatedCommonProperties(modelActivity, activity);

        ValueAdapter.toModel(activity, RefreshSqlEndpointActivity.SQLENDPOINTID, modelActivity.typeProperties.sqlEndpointId);
        ValueAdapter.toModel(activity, RefreshSqlEndpointActivity.WORKSPACEID, modelActivity.typeProperties.workspaceId);
        ValueAdapter.toModel(activity, RefreshSqlEndpointActivity.TIMEOUT, modelActivity.typeProperties.timeout);
        ValueAdapter.toModel(activity, RefreshSqlEndpointActivity.RECREATE_TABLES, modelActivity.typeProperties.recreateTables);

        this._setRefreshSqlConnection(activity, modelActivity);

        activity.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelActivity, RefreshSqlEndpointActivity.MODEL));
        return activity;
    }

    private _setRefreshSqlConnection(activity: RefreshSqlEndpointActivity, modelActivity: IRefreshSqlEndpointActivity): void {
        if (modelActivity.linkedServiceName !== undefined) {
            activity.fabricSqlEndpointMetadataLinkedService = getFabricLsForParameterizedConnections(
                modelActivity.linkedServiceName,
                ModelConstants.fabricSqlEndpointMetadataLinkedService,
                activity);

            if (!activity.fabricSqlEndpointMetadataLinkedService) {
                activity.fabricSqlEndpointMetadataLinkedService = ReferenceAdapter.toProxyModel<FabricSqlEndpointMetadataLinkedService>(Metamodel.modelFor(FabricSqlEndpointMetadataLinkedService),
                    modelActivity.linkedServiceName,
                    this.context);
            }
        }
    }

}
